export const adjustHeight = (el: any) => {
    el.style.height =
        el.scrollHeight >= el.clientHeight && Boolean(el.value) ? el.scrollHeight + "px" : "24px";
};
